module.exports = __webpack_public_path__ + "ath_game_web/media/song.f9771c79.wav";